import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';

import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { TranslateService } from '@ngx-translate/core';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-stages',
  templateUrl: './stages.component.html',
  styleUrls: ['./stages.component.sass']
})
export class StagesComponent implements OnInit {
  stagesListSubs: Subscription;
  stages: any;
  stagesList: Stage[];
  stageForm: FormGroup;
  isList: boolean = true;
  isNew: boolean = false;
  schoolsListSubs: Subscription;
  schools: any;
  modification_date: string;
  creation_date: string;
  stage_name: string;
  type_accept: string;
  selectedFiles: File;

  displayedColumns: string[] = ['name', 'creation_date', 'modification_date', 'actions'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, {}) sort: MatSort;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public firebase: AngularFireAuth,
    private http: HttpClient,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }


  //   public getStages(schoolID: string) {
  //     this.stagesListSubs = this.dataService
  //       .getStages()
  //       .subscribe(res => {
  //         this.stages = res;
  // //           this.usersList = res;
  //         },
  //         console.error
  //       );
  //   }

  //   public getSchools() {
  //     var params={};
  //     params['page'] = 1
  //     params['size'] = 100000
  //     params['search'] = ''
  //     this.schoolsListSubs = this.dataService
  //       .getSchools(params)
  //       .subscribe(res => {
  //         this.schools = res['items'];
  //           // ;
  // //           this.usersList = res;
  //         },
  //         console.error
  //       );
  //   }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.type_accept = '.pdf';
    this.stageForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      name: new FormControl('', Validators.required),
    });

    // this.schools = this.getSchools();
    // this.stages = this.getStages();

    this.route.params.subscribe(params => {
      if ((params.school_id) && (params.stage_id)) {
        this.isList = false;

        // this.getSchools();
        if (params.stage_id != 'new') {
          this.isNew = false;
          this.stagesListSubs = this.dataService
            .getStage(params.stage_id) //cambiar por id en el html
            .subscribe(res => {
              this.stages = res;
              this.stageForm.controls["id"].setValue(this.stages.id);
              this.stageForm.controls["name"].setValue(this.stages.name);

              // this.value = `${environment.WEB_URL}/public/` + this.stages.id;
              this.modification_date = this.stages.modification_date;
              this.creation_date = this.stages.creation_date;
              this.stage_name = this.stages.name;
            },
              console.error
            );
        }
        else {
          this.isNew = true;
        }
        // TODO meter else para visualizar stageo.
      }
      else {
        this.isList = true;
        if (params.id != 'new') {
          this.dataService.getStages(params.id).subscribe(stages => {
            this.stages = stages;
            this.dataSource.data = this.stages;
          });
        }
      }
    });
  }


  goTo(stageID: string) {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/stage/` + stageID);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goBack() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl('school/' + params.school_id + "/1");
    });
  }

  newStage() {
    this.route.params.subscribe(params => {
      this.router.navigateByUrl(params.id + `/stage/new`);
    });
  }


  saveStage(file: any) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = this.stageForm.controls["name"].value;
      params['id'] = this.stageForm.controls["id"].value;
      params['school'] = url_params.school_id;

      if (params['name'] == '') {
        this.translate.get('alerts.name_required').subscribe((res: string) => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        })
        return false;
      }

      this.dataService.saveStage(params).subscribe(data => {
        if (data == '') {
          this.goBack()
        }
        else {
          this.translate.get('alerts.save_stage_error').subscribe((res: string) => {
            this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          })
        }
      })
    })
  }

  delete(id_stage: string) {
    this.route.params.subscribe(url_params => {
      var params = {};
      params['name'] = '';
      params['id'] = id_stage;
      params['school'] = url_params.id;


      // this.dataService.deleteStage(params).subscribe( data => {
      //   if (data == 'Stage deleted'){
      //     alert(data);
      //     window.location.reload();
      //     // this.router.navigateByUrl(`school/` + params['school']);
      //   }
      //   else{
      //     alert(data);
      //   }  
      // })
    });
  }


  changeFormat() {
    if (this.stageForm.controls["type"].value == 'pdf') {
      this.type_accept = '.pdf';
    }
    else if (this.stageForm.controls["type"].value == 'img') {
      this.type_accept = '.jpeg, .png, .jpg, .svg';
    }
    else {
      this.type_accept = '.mp4, .avi, .flv, .mov, .wmv, .divx';
    }

  }
}



export class Stage {
  constructor(
    public name: string,
    public type: string,
    public id: number,
    public school: string

  ) { }
}